import React from 'react';

import { EDX_BENEFITS, EDX_GIFT_UPSELL_URL, EDX_TESTIMONIALS } from '@edb/config/app';

import { PricingPage } from '@edx/pages/pricing';

const bgImage = {
  small: '/img/pricing/pricing_heading-s.jpg',
  medium: '/img/pricing/pricing_heading-m.jpg',
  large: '/img/pricing/pricing_heading-l.jpg',
};

const PrecioPage: React.FC = () => (
  <PricingPage
    bgImage={bgImage}
    benefits={EDX_BENEFITS}
    testimonials={EDX_TESTIMONIALS}
    giftUpsellUrl={EDX_GIFT_UPSELL_URL}
  />
);

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
PrecioPage.navBar = { position: 'absolute', variant: 'transparent' };

export default PrecioPage;
